import * as React from "react";
import images from "./assets/images";

const Decoration: React.FC = () => {
  return (
    <div>
      <img src={images.anvelopeImg} alt="" />.
    </div>
  );
};

export default Decoration;
